import apiV2 from '../../api/v2';

export interface ScanHistoryEntry {
    scanId: number;
    instruction: 'go' | 'nogo' | 'go_back';
    alignerIndex: number | null;
    late: boolean;
}

export interface ComplianceData {
    /**
     * False when this monitoring issues no aligner-change instructions at all
     * (a fixed appliance, say). Every instruction figure below is then null by
     * definition, and only the scan-cadence ones carry meaning.
     */
    tracksAligners: boolean;
    /**
     * Aligner tracking rate: go / (go + nogo + go_back).
     * Reflects whether teeth are progressing on plan — NOT patient behavior.
     */
    trackingPct: number | null;
    goCount: number;
    nogoCount: number;
    goBackCount: number;
    consecutiveNogos: number;
    lateCount: number;
    onTimeCount: number;
    latePct: number | null;
    lastScan: {
        instruction: 'go' | 'nogo' | 'go_back';
        date: string;
        alignerIndex: number | null;
    } | null;
    scanHistory: ScanHistoryEntry[];
}

/**
 * Same `/patients/:id/monitoring/compliance` endpoint files-viewer's
 * overview Treatment card uses. `apiV2`'s response interceptor already
 * unwraps the `{success, data}` envelope, so `response.data` here is the
 * `ComplianceData` payload directly (no extra `.data.data` step).
 */
export async function fetchDmCompliance(patientId: string): Promise<ComplianceData | null> {
    const response = await apiV2.get<ComplianceData | null>(
        `/patients/${encodeURIComponent(patientId)}/monitoring/compliance`
    );
    return response.data;
}
